export const ACCESS_TOKEN = 'accessToken';

export const DEFAULT_LANG = process.env.REACT_APP_DEFAULT_LANG || 'en';
export const DEFAULT_THEME = process.env.REACT_APP_DEFAULT_THEME || 'light';

// Fallback backend used only when REACT_APP_API_URL is not injected at build time
// (e.g. local `npm run build` / `craco start`). Deployed images set REACT_APP_API_URL
// explicitly per environment in Dockerfile.prod / Dockerfile.preprod, which wins over
// this value. Kept at preprod so local/dev builds never point at the production DB.
const backend = 'https://api.preprod.kucing.sg';

export const BASE_URL = process.env.REACT_APP_BASE_URL || '/';
export const API_URL = process.env.REACT_APP_API_URL || backend;
export const WS_URL = process.env.REACT_APP_WS_URL || backend;
export const BASE_URL_IMG = process.env.REACT_APP_BASE_URL_IMG || backend;

export const CLIENT_ID_GOOGLE = '335658829035-9m36i52t5mu0f8iota6gsm3cl7ee992o.apps.googleusercontent.com';
export const APP_ID_FACEBOOK = '456327779451998';

export const TOKEN_MAP_BOX =
  'pk.eyJ1Ijoia3VjaW5nb2ZmaWNpYWwiLCJhIjoiY2xlZGw1bTJoMDBtdTN0b2NoY3Q5dXh1dSJ9.ltnoajYNQAkmv1yaFu1G2g';
// export const STYLE_URL_MAP = 'mapbox://styles/kucingofficial/cledz11oe001i01msq99a8fwi';
// export const STYLE_URL_SATELITE = 'mapbox://styles/kucingofficial/cledxe6u6002l01k5ewnm8pjr';
// export const STYLE_URL_MAP3D = 'mapbox://styles/kucingofficial/clee0bx8400e501qmkr0zhlpx';

export const STYLE_URL_MAP = 'mapbox://styles/kucingofficial/clfi9tntg001h01mpdddo7x7k';
export const STYLE_URL_SATELITE = 'mapbox://styles/kucingofficial/clfi9tntg001h01mpdddo7x7k';
export const STYLE_URL_MAP3D = 'mapbox://styles/kucingofficial/clfi9tntg001h01mpdddo7x7k';

// SOLD
export const GEOJSON_PARCEL = `${API_URL}/get-polygones`;
// RENTED
export const GEOJSON_PARCEL_RENTED = `${API_URL}/get-polygones-rental`;

// SOLD
export const GEOJSON_DISTRICT = `${API_URL}/get-district-polygons`;
// RENTED
export const GEOJSON_DISTRICT_RENTED = `${API_URL}/get-district-polygons-rental`;

// SOLD
export const GEOJSON_NOLANDED = `${API_URL}/get-geojson-nolanded`;
export const GEOJSON_LANDED = `${API_URL}/get-geojson-landed`;
export const GEOJSON_HDB = `${API_URL}/get-geojson-hdb`;
// RENTED
export const GEOJSON_NOLANDED_RENTED = `${API_URL}/get-geojson-nolanded-rental`;
export const GEOJSON_LANDED_RENTED = `${API_URL}/get-geojson-landed-rental`;
export const GEOJSON_HDB_RENTED = `${API_URL}/get-geojson-hdb-rental`;

export const testENV = process.env.REACT_APP_API_URL;

export const key: string = 'oiefoiwef8f0wihf4i';

export const GOOGLE_STREET_VIEW_KEY = 'AIzaSyC9dyO5I9df-RLNMIfc7gbESxW_vKntz8Q';
